/**
* @author Andrés Camilo Ferreira Rodríguez
* @Copyright (c) Infotrack. All rights reserved.
*/
export default {
'sidebar.smartstock': 'Smart  Stock',
'sidebar.tiposMovimientos': 'Tipos  Movimientos',
'tiposMovimientos.agregarTipos Movimientos': 'Create Tipos  Movimientos',
'tiposMovimientos.modificarTipos Movimientos': 'Edit Tipos  Movimientos',
'tiposMovimientos.eliminarTipos Movimientos': 'Delete Tipos  Movimientos',
'tiposMovimientos.tipoMovimientoId': 'Tipo   Movimiento   Id ',
'tiposMovimientos.empresaId': ' Empresa   Id ',
'tiposMovimientos.tipoMovimientoDescripcion': 'Descripcion',
'tiposMovimientos.tipos Movimientos': 'Tipos  Movimientos',
'tiposMovimientos.verTipos Movimientos': 'View Tipos  Movimientos',
};

